import React, { useEffect, useState, useRef } from "react";
import {
  Input,
  Table,
  Button,
  IconButton,
  SelectPicker,
  toaster,
  Message,
  NumberInput,
} from "rsuite";
import { VscEdit, VscSave } from "react-icons/vsc";
import { FaPlus, FaSync } from "react-icons/fa";
import { LayoutHome } from "../LayoutHome";
import { Card, notification } from "antd";
import {
  getListServicios,
  getListTipoDocs,
  updateServicio,
} from "../Services/CatalogosServices";

const { Column, HeaderCell, Cell } = Table;

const styles = `
.table-cell-editing .rs-table-cell-content {
  padding: 4px;
}
.table-cell-editing .rs-input {
  width: 100%;
}
`;

export const Servicios = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [data, setData] = useState([]);
  const [dataTD, setDataTD] = useState([]);

  const initialized = useRef(false);
  const [api, contextHolder] = notification.useNotification();

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  const successNotification = (title, msj) => {
    api.success({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#ECFFE0" } },
      showProgress: true,
    });
  };

  const handleChange = (id, key, value) => {
    const nextData = Object.assign([], data);
    nextData.find((item) => item.id === id)[key] = value;
    setData(nextData);
  };

  const handleEdit = (id) => {
    const nextData = Object.assign([], data);
    const activeItem = nextData.find((item) => item.id === id);

    activeItem.status = activeItem.status ? null : "EDIT";

    setData(nextData);
  };

  const handleChangeTD = (id, key, value) => {
    const nextData = Object.assign([], dataTD);
    nextData.find((item) => item.id === id)[key] = value;
    setDataTD(nextData);
  };

  const handleEditTD = (id) => {
    const nextData = Object.assign([], dataTD);
    const activeItem = nextData.find((item) => item.id === id);

    activeItem.status = activeItem.status ? null : "EDIT";

    setDataTD(nextData);
  };

  const loadListServicios = async () => {
    await getListServicios(idNegocio)
      .then((response) => {
        setData(response);
      })
      .then(async (next) => {
        loadListTipoDocs();
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Error de inicio",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/#/App`;
          }, 1200);
        } else {
          errorNotificaction(error.name, error.message);
        }
      });
  };

  const loadListTipoDocs = async () => {
    await getListTipoDocs(idNegocio)
      .then((res) => {
        setDataTD(res);
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      loadListServicios();
    }
  }, []);

  return (
    <>
      <title>Catálogo de Servicios - NefroSys</title>
      <LayoutHome
        titleItems={[
          {
            title: (
              <a href="/#/App/Home" style={{ textDecoration: "none" }}>
                Menú
              </a>
            ),
          },
          { title: "Catálogo de Servicios" },
        ]}
        selectedKey={"1.6"}
      >
        {contextHolder}
        <style>{styles}</style>
        <Card title="Lista de Servicios">
          <div className="row">
            <div className="col">
              <>
                <Button
                  appearance="ghost"
                  startIcon={<FaPlus></FaPlus>}
                  color="blue"
                  onClick={() => {
                    setData([
                      {
                        id: data.length + 1,
                        servicio: "",
                      },
                      ...data,
                    ]);
                  }}
                >
                  Agregar registro
                </Button>
                &nbsp;
                <Button
                  appearance="ghost"
                  onClick={getListServicios}
                  startIcon={<FaSync></FaSync>}
                >
                  Actualizar
                </Button>
                <hr />
                <Table
                  height={300}
                  hover={true}
                  showHeader={true}
                  data={data}
                  bordered={true}
                  cellBordered={true}
                  headerHeight={30}
                  rowHeight={40}
                >
                  <Column flexGrow={1}>
                    <HeaderCell style={{ fontWeight: "bold" }}>
                      NOMBRE DEL SERVICIO
                    </HeaderCell>
                    <EditableCell
                      dataKey="servicio"
                      dataType="string"
                      onChange={handleChange}
                      onEdit={handleEdit}
                    />
                  </Column>

                  <Column flexGrow={1}>
                    <HeaderCell align="center" style={{ fontWeight: "bold" }}>
                      MOSTRAR EN PANTALLA DE INICIO
                    </HeaderCell>
                    <EditableCell
                      align="center"
                      dataKey="mostrar"
                      dataType="picker"
                      onChange={handleChange}
                      onEdit={handleEdit}
                    />
                  </Column>

                  <Column width={200}>
                    <HeaderCell align="right" style={{ fontWeight: "bold" }}>
                      PRECIO
                    </HeaderCell>
                    <EditableCell
                      align="right"
                      dataKey="precio"
                      dataType="number"
                      onChange={handleChange}
                      onEdit={handleEdit}
                    />
                  </Column>

                  <Column flexGrow={1}>
                    <HeaderCell align="center" style={{ fontWeight: "bold" }}>
                      ACTIVO
                    </HeaderCell>
                    <EditableCell
                      align="center"
                      dataKey="estatus"
                      dataType="picker"
                      onChange={handleChange}
                      onEdit={handleEdit}
                    />
                  </Column>

                  <Column width={100}>
                    <HeaderCell align="center" style={{ fontWeight: "bold" }}>
                      ...
                    </HeaderCell>
                    <ActionCell dataKey="id" onEdit={handleEdit} />
                  </Column>
                </Table>
              </>
            </div>
          </div>
        </Card>
      </LayoutHome>
    </>
  );
};

function toValueString(value, dataType) {
  return dataType === "date" ? value?.toLocaleDateString() : value;
}

const fieldMap = {
  string: Input,
  number: NumberInput,
  picker: SelectPicker,
};

const EditableCell = ({
  rowData,
  dataType,
  dataKey,
  onChange,
  onEdit,
  ...props
}) => {
  const editing = rowData.status === "EDIT";

  const Field = fieldMap[dataType];
  const value = rowData[dataKey];
  const text = toValueString(value, dataType);

  return (
    <Cell
      {...props}
      className={editing ? "table-cell-editing" : ""}
      onDoubleClick={() => {
        onEdit?.(rowData.id);
      }}
    >
      {editing ? (
        <Field
          defaultValue={value}
          searchable={false}
          min={0}
          data={[
            { label: "SI", value: "SI" },
            { label: "NO", value: "NO" },
          ]}
          onChange={(value) => {
            onChange?.(rowData.id, dataKey, value);
          }}
        />
      ) : (
        text
      )}
    </Cell>
  );
};

const toast = (msg, type = "info") => {
  toaster.push(
    <Message showIcon type={type} closable>
      <strong>{type}!</strong>
      &nbsp; {msg}
    </Message>,
    { duration: 5000, placement: "topCenter" },
  );
};

const saveRecord = async (id, rowData, mode) => {
  if (mode === "EDIT") {
    return;
  }
  let url = "";
  const idNegocio = JSON.parse(localStorage.getItem("auth")).id;
  const idUser = JSON.parse(localStorage.getItem("auth")).idUser;

  const data = {
    id: idNegocio,
    idServ: rowData.id,
    servicio: rowData.servicio,
    mostrar: rowData.mostrar,
    idPrecio: rowData.idPrecio,
    precio: rowData.precio,
    idUser: idUser,
    estatus: rowData.estatus,
  };

  await updateServicio(data)
    .then(async (res) => {
      if (res.data === 1) {
        toast("El registro se ha actualizado de forma correcta", "success");
      } else {
        toast("No se ha registrado la información", "warning");
      }
    })
    .catch((error) => {
      toast("Ha ocurrido un error inesperado.", "error");
      console.log(error);
    });
};

const ActionCell = ({ rowData, dataKey, onEdit, onRemove, ...props }) => {
  return (
    <Cell
      {...props}
      style={{ padding: "6px", display: "flex", gap: "4px" }}
      align="center"
    >
      <IconButton
        appearance="subtle"
        icon={rowData.status === "EDIT" ? <VscSave /> : <VscEdit />}
        onClick={() => {
          onEdit(rowData.id);
          saveRecord(rowData.id, rowData, rowData.status);
        }}
      />
    </Cell>
  );
};
